<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-row>
      <v-col cols="12">
        <v-card-title>
          <v-col cols="12" md="4" class="mr-5">
            Doctors
            <v-btn depressed small color="primary" append-icon="mdi-printer" v-on:click="printListAll">
              <v-icon>mdi-printer</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" md="3" sm="12" class="">
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                dense
                hide-details
                outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3" sm="12" class="">
            <v-autocomplete
                class="mr-1"
                :items="['','Specialist Doctor', 'Referral Doctor']"
                v-model="dr_type"
                required
                label="Select Dr Type"
                outlined
                dense
                hide-details
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3" md="1" v-if="checkPermissionHasOrNot(DOCTOR_CREATE_EDIT)">
            <template>
              <v-row align="center" justify="space-around">
                <v-btn depressed color="info" @click="addItem" class="mt-2">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-row>
            </template>
          </v-col>
        </v-card-title>
        <v-card>
          <v-data-table
              :headers="headers"
              :items="desserts"
              class="elevation-1"
              :search="search"
              :loading="loading_status"
          >
            <template v-slot:item.status="{ item }">
              <v-chip v-if="item.status == 1" dark color="green" label outlined small>Active</v-chip>
              <v-chip v-else dark color="red" label outlined small>Inactive</v-chip>
            </template>
            <template v-slot:item.appointment_status="{ item }">
              <v-chip v-if="item.appointment_status == 1" dark color="green" label outlined small>Online</v-chip>
              <v-chip v-else dark color="red" label outlined small>Offline</v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-chip @click="viewItem(item)" dark class="ma-2" open color="info" outlined small
                      title="See Doctor Details">
                <v-icon>mdi-eye</v-icon>
              </v-chip>
              <v-chip
                  v-if="checkPermissionHasOrNot(DOCTOR_CREATE_EDIT)"
                  @click="editItem(item)"
                  dark
                  class="ma-2"
                  open
                  color="success"
                  outlined
                  small
                  title="Edit Doctor"
              >
                <v-icon> mdi-pencil</v-icon>
              </v-chip>
            </template>

            <template v-slot:no-data>
              <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <template>
      <div class="text-center">
        <v-dialog v-model="dialog" width="600">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2"> {{ modalLabel }}</v-card-title>
            <v-card-text>
              <v-row class="mt-2">
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                      v-model="submitData.dr_name"
                      label="Doctor Name"
                      outlined
                      dense
                      hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                      v-model="submitData.dr_phone"
                      label="Phone"
                      outlined
                      dense
                      hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                      v-model="submitData.dr_email"
                      label="Email"
                      outlined
                      dense
                      hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                      v-model="submitData.room_no"
                      label="Room No"
                      outlined
                      dense
                      hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                      v-model="submitData.org_name"
                      label="Hospital Name"
                      outlined
                      dense
                      hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-autocomplete
                      v-model="submitData.dr_type"
                      :items="practiceType"
                      item-text="content"
                      item-value="id"
                      label="Practice Type"
                      outlined
                      dense
                      hide-details
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                      v-model="submitData.dr_address"
                      label="Address"
                      outlined
                      dense
                      hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                      v-model="submitData.status"
                      :items="status"
                      item-value="key"
                      item-text="value"
                      label="Doctor Status"
                      outlined
                      dense
                      hide-details
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-checkbox
                      v-model="submitData.general_consultation_block"
                      label="Block General Consultation"
                      :true-value="1"
                      :false-value="0"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-checkbox
                      v-model="submitData.show_other_dr_followup"
                      label="Show Other Doctor Followup"
                      :true-value="1"
                      :false-value="0"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <label for="">Designation</label>
                  <vue-editor
                      v-model="submitData.dl_designation"
                      outlined
                      label="Designation"
                      hide-details
                  ></vue-editor>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                      v-model="submitData.consultancy_fee"
                      label="Consultancy Fee"
                      type="number"
                      outlined
                      dense
                      hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                      v-model="submitData.re_consultancy_fee"
                      label="Re Consultancy Fee"
                      type="number"
                      outlined
                      dense
                      hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                      v-model="submitData.opd_consultancy_fee"
                      label="OPD Consultancy Fee"
                      type="number"
                      outlined
                      dense
                      hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                      v-model="submitData.opd_re_consultancy_fee"
                      label="OPD Re Consultancy Fee"
                      type="number"
                      outlined
                      dense
                      hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                      v-model="submitData.rop_consultancy_fee"
                      label="Rop Re Consultancy Fee"
                      type="number"
                      outlined
                      dense
                      hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                      v-model="submitData.rop_re_consultancy_fee"
                      label="Rop Re Consultancy Fee"
                      type="number"
                      outlined
                      dense
                      hide-details
                  ></v-text-field>
                </v-col>


              </v-row>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <div v-if="spinnerButtons">
                <v-progress-circular :width="12" size="61" color="green" indeterminate
                                     style="margin-top: 5px; margin-bottom: 10px"></v-progress-circular>
              </div>
              <div v-else>
                <v-btn color="warning" @click="dialog = false"> Cancel</v-btn>
                <v-btn color="primary" class="ms-2" @click="dataSubmit"> Submit</v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>

    </template>
  </div>
</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";
import {VueEditor} from "vue2-editor";
import PermissionName from "@/js/PermissionName";


export default {
  components: {
    VueEditor
  },
  data() {
    return {
      DOCTOR_CREATE_EDIT: PermissionName.DOCTOR_CREATE_EDIT,
      spinnerButtons: false,
      menu: false,
      menu1: false,
      selectedDate: null,
      selectedDates: [],
      loading_status: true,
      AppSelectedDate: null,
      AppSelectedDates: [],
      returnUrl: atshq.defaults.headers.common.app_URL,
      returnApiBaseURL: atshq.defaults.headers.common.api_base_URL,
      search: "",
      dialog: false,
      appointment_time_slot_dialog: false,
      dr_type: '',
      headers: [
        {
          text: "ID",
          align: "start",
          sortable: true,
          value: "dr_id",
        },
        {text: "Name", value: "dr_name"},
        {text: "Phone", value: "dr_phone"},
        {text: "Dr Type", value: "dr_type"},
        {text: "Status", value: "status"},
        {text: "Appointment Status", value: "appointment_status"},
        {text: "Action", value: "actions", sortable: false},
      ],
      myValue: '',
      desserts: [],
      practiceType: ['Specialist Doctor', 'Referral Doctor'],
      status: [
        {key: 1, value: "Active"},
        {key: 0, value: "Inactive"},
      ],
      appointment_status: [
        {key: 1, value: "Online"},
        {key: 0, value: "Offline"},
      ],
      modalLabel: null,
      EditedModalLabel: null,
      submitData: {
        dr_id: null,
        dr_name: null,
        dr_type: null,
        dr_phone: null,
        dr_email: null,
        dl_designation: null,
        room_no: null,
        org_name: null,
        dr_address: null,
        consultancy_fee: '',
        re_consultancy_fee: '',
        opd_consultancy_fee: '',
        opd_re_consultancy_fee: '',
        rop_consultancy_fee: '',
        rop_re_consultancy_fee: '',
        general_consultation_block:0,
        show_other_dr_followup:0,

        status: 1,
        district_id: '',
        user_id: localStorage.getItem("userId"),
      },
      submitAppointmentScheduleData: {
        dr_id: null,
        appointment_status: '',
        appointment_day: '',
        appointment_start_time: '',
        appointment_end_time: '',
        start_break_time: null,
        end_break_time: null,
      },

      appointment_schedule_headers: [
        {text: 'Appointment Day', align: 'start', value: 'appointment_day'},
        {text: 'Start Time', value: 'appointment_start_time'},
        {text: 'End Time', value: 'appointment_end_time'},
        {text: 'Break Time', value: 'break_time'},
        {text: 'Actions', value: 'actions', sortable: false}
      ],
      appointment_schedule_data: [],
      errors: [],
      districts: [],
      divisions: [],
      editedAppointmentItemDialog: false,
      editedAppointmentItem: {
        id: null,
        doctor_id: null,
        appointment_status: '',
        appointment_day: '',
        appointment_start_time: '',
        appointment_end_time: '',
        start_break_time: '',
        end_break_time: '',
      },
      deleteDialog: false,
      deleteItem: null,
      appointmentNoteDialog: false,
      appointmentNoteTime: {
        doctor_id: null,
        appointment_note: '',
        appointment_off_dates: [],
        user_id: localStorage.getItem("userId"),
      },

      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Doctors",
          disabled: true,
          href: "doctors",
        },
      ],
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.permissionExists(PermissionName.DOCTOR_LIST);
    this.initialize();
  },
  watch: {
    dr_type() {
      this.loading_status = true;
      this.initialize()
    }
  },
  methods: {
    initialize() {
      atshq
          .get("doctors?dr_type=" + this.dr_type)
          .then((response) => {
            // JSON responses are automatically parsed.
            this.desserts = response.data.data;
            this.loading_status = false
          })
          .catch((e) => {
            this.errors.push(e);
            this.loading_status = false
          });

    },

    dataSubmit() {
      if (this.submitData.dr_id) {
        this.spinnerButtons = true
        atshq
            .put('doctors/' + this.submitData.dr_id, {
              submitData: this.submitData
            })
            .then((response) => {
              this.$noty.success(response.data.message);
              this.dialog = false;
              this.spinnerButtons = false
              this.initialize()
            })
            .catch((e) => {
              this.spinnerButtons = false
              this.$noty.error(e.response.message);
              console.log(e)
            });
      } else {
        this.spinnerButtons = true
        atshq
            .post('doctors', {
              submitData: this.submitData
            })
            .then((response) => {
              this.$noty.success(response.data.message);
              this.dialog = false;
              this.initialize()
              this.spinnerButtons = false
            })
            .catch((e) => {
              this.spinnerButtons = false
              this.$noty.error(e.response.message);
            });
      }
    },

    printListAll() {
      window.open(this.returnApiBaseURL + "print/doctors?dr_type=" + this.dr_type);
    },
    addItem() {
      this.submitData.dr_id = null
      this.submitData.dr_name = null
      this.submitData.dr_type = null
      this.submitData.dr_phone = null
      this.submitData.dr_email = null
      this.submitData.dl_designation = null
      this.submitData.room_no = null
      this.submitData.org_name = null
      this.submitData.dr_address = null
      this.submitData.consultancy_fee = 700
      this.submitData.re_consultancy_fee = 500
      this.submitData.opd_consultancy_fee = 100
      this.submitData.opd_re_consultancy_fee = 100
      this.submitData.rop_consultancy_fee = null
      this.submitData.rop_re_consultancy_fee = null
      this.submitData.status = 1
      this.submitData.district_id = null
      this.submitData.general_consultation_block = 0
      this.submitData.show_other_dr_followup = 0

      this.modalLabel = 'Add Doctor'
      this.dialog = true;
    },
    editItem(item) {

      console.log('inn',item)
      this.modalLabel = 'Edit Doctor'
      this.dialog = true;
      this.submitData.dr_id = item.id
      this.submitData.dr_name = item.dr_name
      this.submitData.dr_type = item.dr_type
      this.submitData.dr_phone = item.dr_phone
      this.submitData.dr_email = item.dr_email
      this.submitData.dl_designation = item.dl_designation
      this.submitData.room_no = item.room_no
      this.submitData.org_name = item.org_name
      this.submitData.dr_address = item.dr_address
      this.submitData.consultancy_fee = item.consultancy_fee
      this.submitData.re_consultancy_fee = item.re_consultancy_fee
      this.submitData.opd_consultancy_fee = item.opd_consultancy_fee
      this.submitData.opd_re_consultancy_fee = item.opd_re_consultancy_fee
      this.submitData.rop_consultancy_fee = item.rop_consultancy_fee
      this.submitData.rop_re_consultancy_fee = item.rop_re_consultancy_fee
      this.submitData.general_consultation_block = parseInt(item.general_consultation_block)
      this.submitData.show_other_dr_followup = parseInt(item.show_other_dr_followup)

      this.submitData.district_id = item.district_id
      this.submitData.status = parseInt(item.status)
    },
    viewItem(item) {
      window.location.href = "doctor-details/" + item.dr_id;
    }
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 300px;
  text-align: center;
}

.modal-actions {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
}
</style>